// Admin grod for conected-accoutn on a clientId

import React from 'react';
import { Tag, Row, Col, Button, Typography, Space } from 'antd';
import firebase from 'firebase/app';

import CenteredSpinner from '../CenteredSpinner';
import { useClientConnectedAccounts } from '../../models/useClientConnectedAccounts';
import { useClient } from '../../models/useClient';

const { Text } = Typography;

export const AdminGridClientConnectAccounts = ({ clientId, isConnect }) => {
    const [loadingAccounts, connectedAccounts, errorAccounts ] = useClientConnectedAccounts(clientId);
    const [loadingClient, client, errorClient] = useClient(clientId);

    if (loadingAccounts || loadingClient) return <CenteredSpinner loading />;

    if (errorAccounts || errorClient) return <div style={{ color: 'red' }}>{(errorAccounts || errorClient).message}</div>;

    const handleTransferModeToggle = async () => {
        const { transferMode } = client || {};
        const isOnWithdrawal = transferMode === 'on_withdrawal';
        const newMode = isOnWithdrawal ? 'on_payment' : 'on_withdrawal';
        
        try {
            const db = firebase.firestore();
            await db.collection('clients').doc(clientId).update({
                transferMode: newMode,
                updatedAt: firebase.firestore.Timestamp.now()
            });
        } catch (err) {
            console.error('Error updating transfer mode:', err);
        }
    };

    const TransferModeSection = () => {
        // Transfer Mode logic only applies to US clients
        if (client?.country !== 'US') return null;

        const { transferMode } = client || {};
        const isOnWithdrawal = transferMode === 'on_withdrawal';

        return (
            <Row style={{ marginTop: '12px', alignItems: 'center' }}>
                <Text strong style={{ marginRight: '8px' }}>Transfer Mode:</Text>
                {isOnWithdrawal ? (
                    <Space>
                        <Tag color="green">Migrated to On Withdrawal</Tag>
                        <Button size="small" onClick={handleTransferModeToggle}>Revert</Button>
                    </Space>
                ) : (
                    <Button size="small" type="primary" onClick={handleTransferModeToggle}>
                        Migrate to On Withdrawal
                    </Button>
                )}
            </Row>
        );
    };

    const CapabilitiesTags = ({ capabilities, id }) => { 
        const { transfers, payouts } = capabilities || {};
        const transfersColor = transfers === 'active' ? "green" : "red";
        const payoutsColor = payouts === 'active' ? "green" : "red";

        return (
            <>
                <Tag key={`${id}-transfers`} color={transfersColor}>Transfers</Tag>
                <Tag key={`${id}-payouts`} color={payoutsColor}>Payouts</Tag>
            </>
        );
    };

    if (!connectedAccounts || !connectedAccounts.length) { 
        return (
            <Col>
                <Row>
                    { isConnect ? <Tag key="no-account" color="red">No account</Tag> : null }
                </Row>
                <TransferModeSection />
            </Col>
        );
    }

    return (
        <Col >
            {connectedAccounts.map((a) => (
                <Row key={`${a.id}-connect-row`} style={{ marginBottom: '4px' }}>
                    <Tag key={`${a.id}-acctId`} color="darkblue">{a.connectedAccountId ?? a.id}</Tag>
                    <CapabilitiesTags key={`${a.id}-capabilities`} capabilities={a.capabilities || {}} id={a.id} />
                </Row>
            ))}
            <TransferModeSection />
        </Col>
    );
};
